import { render, staticRenderFns } from "./ImportRegistrants.vue?vue&type=template&id=30608610&"
import script from "./ImportRegistrants.vue?vue&type=script&lang=js&"
export * from "./ImportRegistrants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports